"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styled = require("./styled");
var _styledComponents = require("styled-components");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const Text = _ref => {
  let {
    bold,
    children,
    color,
    fontSize = "12px",
    fontWeight,
    italic,
    margin = "0px",
    textAlign = "left",
    textDecoration,
    whiteSpace = "normal",
    wordBreak = "normal"
  } = _ref;
  const {
    textColor
  } = (0, _styledComponents.useTheme)();
  const spanProps = {
    bold,
    color: color !== null && color !== void 0 ? color : textColor,
    fontSize,
    fontWeight,
    italic,
    margin,
    textAlign,
    textDecoration,
    whiteSpace,
    wordBreak
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.StyledP, _objectSpread(_objectSpread({}, spanProps), {}, {
    children: children
  }));
};
Text.propTypes = {
  bold: _propTypes.default.bool,
  children: _propTypes.default.string,
  color: _propTypes.default.string,
  fontSize: _propTypes.default.string,
  italic: _propTypes.default.bool,
  margin: _propTypes.default.string,
  textAlign: _propTypes.default.string,
  textDecoration: _propTypes.default.string,
  whiteSpace: _propTypes.default.string,
  wordBreak: _propTypes.default.string
};
var _default = exports.default = Text;